import React from "react";
import { useTranslation } from "react-i18next";

interface Props {}

const Logo: React.FC<Props> = () => {
  const { i18n } = useTranslation();
  return i18n.language === "en" ? (
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 954.545 200"
    >
      <g id="Warstwa_1_1_">
        <g id="Layer_1">
          <g>
            <path
              style={{ fill: "#003F85" }}
              d="M931.741,2h-128c-14.359,0-27.533,11.64-29.424,26c-1.894,14.359,8.218,26,22.574,26h36.003
       l-15.566,118c-2.036,15.464,8.849,28,24.312,28c15.463,0,29.649-12.536,31.688-28l15.566-118h35.998
       c14.356,0,27.531-11.641,29.425-26C956.208,13.64,946.097,2,931.741,2z"
            />
            <path
              style={{ fill: "#003F85" }}
              d="M146.531,2H50.53C35.064,2,20.881,14.536,18.843,30L0.245,170c-2.036,15.464,8.849,28,24.312,28
       h96c14.357,0,27.532-11.643,29.423-26c1.893-14.359-8.22-26-22.575-26H59.403L71.68,54h68c14.357,0,27.533-11.641,29.423-26
       C170.999,13.64,160.888,2,146.531,2z"
            />
            <circle
              style={{ fill: "#003F85" }}
              cx="111.921"
              cy="100"
              r="31"
            />
            <path
              style={{ fill: "#003F85" }}
              d="M736.025,0c-15.467,0-29.649,12.535-31.688,28l-9.298,70.623l-57.023-87.315
       C633.816,4.447,626.235,0,617.025,0c-15.467,0-29.649,12.536-31.688,28L566.38,172c-2.036,15.465,8.849,28,24.313,28
       c15.464,0,29.647-12.535,31.687-28l9.095-69.084l57.892,86.796c0.023,0.038,0.052,0.078,0.078,0.117l0.006,0.009
       c4.315,6.207,11.56,10.162,20.244,10.162c15.467,0,29.649-12.535,31.688-28L760.34,28C762.376,12.536,751.491,0,736.025,0z"
            />
            <path
              style={{ fill: "#003F85" }}
              d="M464.115,0c-60.13,0-105.08,37.389-113.166,100c-8.138,63,26.803,100,86.835,100
       c59.876,0,104.714-37,113.165-100C559.348,37.38,524.268,0,464.115,0z M494.95,100c-4.082,31-23.284,48-50.319,48
       c-27.484,0-41.762-17-37.681-48s22.86-48,50.316-48C484.433,52,499.032,69,494.95,100z"
            />
            <path
              style={{ fill: "#003F85" }}
              d="M292.167,140.477c-7.703,4.972-17.005,7.523-27.536,7.523c-27.484,0-41.762-17-37.681-48
       c4.081-31,22.861-48,50.317-48c10.783,0,19.582,2.683,26.021,7.851l0.004-0.004c4.323,3.562,10.118,5.699,16.734,5.699
       c15.463,0,29.531-11.642,31.423-26c1.062-8.062-1.859-15.309-7.401-20.078c-0.016-0.015,0.019,0.014,0,0l0,0
       C329.411,6.822,308.969,0,284.115,0c-60.13,0-105.08,37.389-113.166,100c-8.138,63,26.803,100,86.835,100
       c23.424,0,44.724-6.314,62.176-17.741c7.807-4.706,13.528-12.471,14.685-21.257c1.893-14.359-9.112-26-24.575-26
       C303.592,135.002,297.362,137.047,292.167,140.477z"
            />
          </g>
        </g>
        <g id="Layer_2"></g>
      </g>
      <g id="Warstwa_1"></g>
    </svg>
  ) : (
    <svg
      width="154"
      height="32"
      viewBox="0 0 154 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M149.845 0.320068H129.328C127.027 0.320068 124.915 2.18247 124.612 4.48007C124.309 6.77767 125.929 8.64007 128.23 8.64007H134.001L131.506 27.5201C131.18 29.9943 132.924 32.0001 135.403 32.0001C137.882 32.0001 140.155 29.9943 140.482 27.5201L142.977 8.64007H148.747C151.048 8.64007 153.16 6.77767 153.463 4.48007C153.767 2.18247 152.146 0.320068 149.845 0.320068Z"
        fill="#003F85"
      />
      <path
        d="M23.9869 0.320068H8.59942C6.1206 0.320068 3.84695 2.32583 3.52045 4.80007L0.539613 27.2001C0.213272 29.6743 1.95798 31.6801 4.43664 31.6801H19.8241C22.1253 31.6801 24.2371 29.8175 24.5402 27.5201C24.8433 25.2226 23.2226 23.3601 20.9214 23.3601H10.022L11.9899 8.64007H22.8894C25.1906 8.64007 27.3025 6.77767 27.6055 4.48007C27.9087 2.18247 26.2882 0.320068 23.9869 0.320068Z"
        fill="#003F85"
      />
      <path
        d="M18.4393 20.96C21.1835 20.96 23.4082 18.7394 23.4082 16C23.4082 13.2607 21.1835 11.04 18.4393 11.04C15.6951 11.04 13.4705 13.2607 13.4705 16C13.4705 18.7394 15.6951 20.96 18.4393 20.96Z"
        fill="#003F85"
      />
      <path
        d="M118.311 0C115.832 0 113.558 2.00576 113.231 4.48L112.303 11.52H103.007L103.935 4.48C104.261 2.00576 102.516 0 100.038 0C97.5595 0 95.2855 2.00576 94.9589 4.48L91.9203 27.52C91.5941 29.9942 93.3389 32 95.8174 32C98.2959 32 100.57 29.9942 100.896 27.52L101.909 19.84H111.206L110.193 27.52C109.867 29.9942 111.611 32 114.09 32C116.568 32 118.842 29.9942 119.169 27.52L122.207 4.48C122.534 2.00576 120.789 0 118.311 0Z"
        fill="#003F85"
      />
      <path
        d="M75.5322 0C65.8942 0 58.6894 5.98224 57.3933 16C56.0892 26.08 61.6894 32 71.3117 32C80.909 32 88.0959 26.08 89.4506 16C90.7972 5.9808 85.1743 0 75.5322 0ZM80.4746 16C79.8203 20.96 76.7424 23.68 72.409 23.68C68.0039 23.68 65.7152 20.96 66.3693 16C67.0234 11.04 70.0339 8.32 74.4346 8.32C78.7892 8.32 81.1289 11.04 80.4746 16Z"
        fill="#003F85"
      />
      <path
        d="M75.5322 0C65.8942 0 58.6894 5.98224 57.3933 16C56.0892 26.08 61.6894 32 71.3117 32C80.909 32 88.0959 26.08 89.4506 16C90.7972 5.9808 85.1743 0 75.5322 0ZM80.4746 16C79.8203 20.96 76.7424 23.68 72.409 23.68C68.0039 23.68 65.7152 20.96 66.3693 16C67.0234 11.04 70.0339 8.32 74.4346 8.32C78.7892 8.32 81.1289 11.04 80.4746 16Z"
        fill="#003F85"
      />
      <path
        d="M53.9102 9.74511e-09C52.6523 9.74511e-09 51.4491 0.52688 50.5345 1.37056L50.5338 1.36992L50.4692 1.43072C50.4639 1.43568 50.4587 1.44048 50.4534 1.44544L39.6352 11.6192L40.5767 4.48C40.9031 2.00576 39.1583 9.74511e-09 36.6797 9.74511e-09C34.201 9.74511e-09 31.9272 2.00576 31.6007 4.48L28.562 27.52C28.2357 29.9942 29.9804 32 32.459 32C34.9377 32 37.2115 29.9942 37.538 27.52L38.5725 19.676L47.4227 30.4926C47.4357 30.5093 47.4493 30.5251 47.4626 30.5416L47.5325 30.6275L47.533 30.627C48.2256 31.437 49.2705 31.9395 50.4997 31.9395C52.934 31.9397 55.1671 29.9698 55.4878 27.5395C55.6497 26.3126 55.2922 25.2032 54.5859 24.4054L54.5863 24.4048L46.9665 15.6488L55.9449 7.59008L55.9444 7.58944C56.8954 6.78784 57.5725 5.65584 57.7379 4.4C58.0584 1.96992 56.3451 -0.00015999 53.9102 9.74511e-09Z"
        fill="#003F85"
      />
    </svg>
  );
};

export default Logo;
